import React, { forwardRef } from 'react';
import MUIFade, { FadeProps as MUIFadeProps } from '@material-ui/core/Fade';

interface FadeProps extends MUIFadeProps {}

const Fade = forwardRef<unknown, FadeProps>((props, ref) => {
  return <MUIFade {...props} ref={ref} />;
});

Fade.displayName = 'Fade';

export default Fade;
